import { getUA, isAndroid, isIPad13, isMobile } from 'react-device-detect'

import { readAppDeviceInfo, writeAppDeviceInfo } from './storage.service'

const MATHFLAT_ANDROID_APP_USER_AGENT = 'mathflat-android-app'
const MATHFLAT_IPAD_APP_USER_AGENT = 'mathflat-ipad-app'

// 셸이 웹뷰 진입 URL 쿼리로 넘기는 원본 형태라 version 이 문자열이다.
export type AppDeviceInfo = {
  device: string
  version: string
}

export const VersionCode_BeforeExportFix = 110021 // mergePdf 추가 이전 버전
/** 안드로이드 앱이 `v2/exportExamCertificates` 를 처리하기 시작한 버전. 이전 버전은 모르는 이벤트에 업데이트 안내만 띄운다. */
export const VersionCode_ExamCertificatesExport = 110062
/** 안드로이드 앱이 학습지 내보내기에서 `studentIds` 를 다운로드 API 로 넘기기 시작한 버전. 이전 버전은 무시해 학생 이름 없이 인쇄된다. */
export const VersionCode_ExportByStudentIds = 110060
/**
 * 안드로이드 앱이 웹뷰 카메라(권한 grant·capture 촬영)를 처리하기 시작한 버전. 이전 버전에서는 getUserMedia 가 실패한다.
 * TODO: 앱 출시 versionCode 로 확정
 */
export const VersionCode_WebCameraQr = 110063

// storage 를 쓸 수 없는 환경에서도 이번 로드 동안은 동작하도록 남겨두는 폴백.
let inMemoryAppDeviceInfo: ReturnType<typeof readAppDeviceInfo> = null

const getAppDeviceInfo = () => readAppDeviceInfo() ?? inMemoryAppDeviceInfo

export default class WebviewService {
  static isMobile = isMobile
  static isWebPC = !isMobile

  // 셸이 device/version 을 넘기는 경로는 진입 URL 쿼리뿐이다. SPA 라우팅으로 쿼리가 사라진 뒤
  // 전체 페이지 로드가 일어나도 값을 알 수 있도록 웹뷰 세션 저장소를 진실의 출처로 삼는다.
  static get device() {
    return getAppDeviceInfo()?.device
  }

  static get version() {
    return getAppDeviceInfo()?.version
  }

  // 안드로이드 크롬 브라우저
  static isWebAndroid = isMobile && isAndroid && getUA.indexOf(MATHFLAT_ANDROID_APP_USER_AGENT) < 0
  // 안드로이드 매쓰플랫 앱
  static isAppAndroid = isMobile && isAndroid && getUA.indexOf(MATHFLAT_ANDROID_APP_USER_AGENT) > -1
  // 아이패드 브라우저
  static isWebIpad = isIPad13 && getUA.indexOf(MATHFLAT_IPAD_APP_USER_AGENT) < 0
  // 아이패드 매쓰플랫 앱
  static isAppIpad = isIPad13 && getUA.indexOf(MATHFLAT_IPAD_APP_USER_AGENT) > -1
  // 기기가 아이패드 태블릿
  static isIpad = this.isWebIpad || this.isAppIpad
  // 기기가 안드로이드 태블릿
  static isAndroid = this.isWebAndroid || this.isAppAndroid

  static setAppDeviceInfo({ device, version }: Partial<AppDeviceInfo>) {
    const versionCode = parseInt(version ?? '')
    if (!device || !Number.isFinite(versionCode)) return

    inMemoryAppDeviceInfo = { device, version: versionCode }
    writeAppDeviceInfo(inMemoryAppDeviceInfo)
  }
}

globalThis.webviewService = WebviewService
